<template>
  <section class="news-collection">
    <div class="news-collection__list">
      <div v-for="post in items" :key="post.uuid" class="news-collection__item">
        <NewsTeaser :post="post" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps<{
  items: any
}>()
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.news-collection {
  margin: var(--space--xxl) 0;

  &__list {
    @include tools.teasers-grid-item(2);
    row-gap: calc(var(--space--m) * 2);
  }

  &__item {
    padding-left: 0;
  }
}
</style>
